import { mergeMap, first } from 'rxjs/operators';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router, CanActivate } from '@angular/router';
import { DigestService, UserService, TenantService } from '../services';

@Component({
    selector: 'register-form',
    template: `
        <mat-toolbar color="primary">Briefing Center</mat-toolbar>
        <form (ngSubmit)="activateUser()" style="height: 100%" fxLayoutAlign="center center" #activateForm="ngForm">
            <spinner *ngIf="noTouching"></spinner>
            <mat-card *ngIf="!noTouching">
                <mat-card-content>
                    <registration-details></registration-details>
                </mat-card-content>
                <mat-card-actions fxLayout="row" fxLayoutAlign="space-around start">
                    <button mat-raised-button type="submit" color="primary" [disabled]="!activateForm.valid">Activate Account</button>
                </mat-card-actions>
            </mat-card>
        </form>
    `
})
export class RegisterComponent implements OnInit {
    @ViewChild('activateForm', { static: true }) public userFrm: NgForm;
    noTouching: boolean;
    user: any;
    tenant: any;

    constructor(private router: Router,
                private route: ActivatedRoute,
                private digestService: DigestService,
                private tenantService: TenantService,
                private userService: UserService,
                private snackBar: MatSnackBar) {}
    
    activateUser = () => {
        this.noTouching = true;
        this.user.firstName = this.userFrm.value.user.firstName;
        this.user.lastName = this.userFrm.value.user.lastName;
        this.user.password = this.userFrm.value.user.password;
        const createEnabled = this.tenant.settings.noInitialDigest === 'true' ? undefined : true;
        this.userService.activateUser(this.user).pipe(first(),
            mergeMap(() => this.digestService.getDigestConfigurationsForUser(this.user.id, createEnabled)),
            first()
        ).subscribe(() => {
            if(this.route.snapshot.queryParams.originator) {
                this.router.navigateByUrl(this.route.snapshot.queryParams.originator);
            } else {
                this.router.navigate(['/browse', ]);
            }
        });
    };

    ngOnInit() {
        if(this.route.snapshot.queryParams.forgotPassword) {
            this.router.navigate(['/login'], { queryParams: { 'start': 'passwordReset' }});
        } else if(this.route.snapshot.queryParams.invitationCode){
            this.tenantService.getUnauthTenantInfo().subscribe(tenant => this.tenant = tenant);
            this.userService.canActivate(null, this.route.snapshot.queryParams.invitationCode).pipe(first())
            .subscribe(results => {
                if (results.canActivate) {
                    this.user = results.user;
                } else {
                    this.snackBar.open('Your token has expired, please request a new one.', 'OK');
                    this.router.navigate(['/login'], { queryParams: { 'start': 'register' }}); 
                }
            });
        } else {
            this.snackBar.open('Your token has expired, please request a new one.', 'OK');
            this.router.navigate(['/login'], { queryParams: { 'start': 'register' }});
        }
    }
}
